export default class StripeModal {
    
    constructor(stripeData, wrapper, loadData) {

        this.$modal     = $('#modalStripe');
        this.stripeData = stripeData;
        this.loadData   = loadData;
        this.wrapper    = wrapper

        if(!this.loadData){
            this.setData(stripeData);
        }

        if(!$('#stripe-btn').length) {
            $(this.wrapper).append(StripeModal.buildStripeBtn(this.btnLabel));
        }
        
        this.bindStripeBtn();
         
    };
    
    render() {
        
        // Create instance of the cards Element.
        this.cardNumber = this.buildCardElement("cardNumber", "#card-element", "#card-errors");
        this.cardExpiry = this.buildCardElement("cardExpiry", "#card-expiry-element", "#card-expiry-errors");
        this.cardCvc    = this.buildCardElement("cardCvc", "#card-cvc-element", "#card-cvc-errors");
        
        //inits labels
        $('.btn-primary',this.$modal).text(this.payLabel);
        $('h2', this.$modal).text(this.description);
        $('#directDebitAlert').text(this.savedCardAlert);
        $('#payment-form').prop('action', this.formAction);
        
        if(!this.saveCard) {
            $('#directDebitAlert').addClass('hidden');
        } else {
            $('#directDebitAlert').removeClass('hidden');
        }
        
        //event declarations
        $('#payment-form').on('submit',this.submitForm.bind(this));
        $('.btn-close', "#payment-form").on('click', this.destroy.bind(this)); 
    };
    
    destroy(e){
        
        e.preventDefault();
        this.$modal.dialog('close');
        //rebind stripe btn
        this.bindStripeBtn();

        $('input', this.$modal).val('');
        
        //unbind events
        $('.btn-close', "#payment-form").off();
        $('#payment-form').off();
        
        this.cardNumber.destroy();
        this.cardExpiry.destroy();
        this.cardCvc.destroy();
    };

    submitForm(event){

        event.preventDefault();

        $('.btn-primary', '#payment-form').prop('disabled',true);
        
        if(this.charge){
            this.handleCardPayment();
        }else{
            this.handleCardSetup();
        }
          
    };
    
    buildCardElement(type, selector, errorSelector){
        
        let cardElement = this.elements.create(type, this.options);
        cardElement.mount(selector);
        
        cardElement.addEventListener('change', function(event){
            
            let $errorWrapper = $(errorSelector);
            
            if (event.error) {
              $errorWrapper.html(event.error.message);
            } else {
              $errorWrapper.html("");
            }
            
        });
        
        return cardElement;
        
    };

    initModal(autoOpen) {

        this.$modal.dialog({
            autoOpen   : autoOpen,
            width      : 450,
            modal      : true,
            close: function (event, ui) {
                $('.embed embed').removeClass('hidden');
            }
        });
        
        $(".ui-dialog-titlebar").hide();
        this.$modal.removeClass('hidden');
    }
    
    static buildStripeBtn(label){
        if(!label) {
            label = window.i18n.__("Payer par Carte bancaire");
        }
        return $('<div class="stripe"><button id="stripe-btn" type="submit" class="my-2 stripe-button-el btn btn-primary">'+ label +'</button></div>');
	};
    
    /**
     * display the modal when we click on stripe Btn, load data before if needed
     */
	bindStripeBtn(){
	
        $('#stripe-btn').on('click', (e) => {
            
            if(!$(e.currentTarget).hasClass('btn-disabled')) {

                //disable btn for prevent multi click
                $(e.currentTarget).off('click');

                //hide pdf doc preview when popup is opened
                $('.embed embed').addClass('hidden');

                if(this.loadData) {

                    //display modal with loader during fetch data
                    $('#payment-form').css('visibility','hidden');
                    this.initModal(true);
                    
                    //fetch Data
                    this.fetchData().then((data) => {
                        
                        //remove loader
                        MyWindow.awake("modalStripe");
                        $('#payment-form').css('visibility','visible');

                        //set Data
                        this.setData(data);

                        //render fetched data on popup
                        this.render(); 

                    });
                    
                } else {
                    this.initModal(true);
                    this.render(); 
                }
            }
            
		});
	
    };
    
    handleCardSetup(){
        this.stripe.handleCardSetup(
            this.clientSecret, this.cardNumber, {
              payment_method_data: {
                billing_details: {email: $('input[name="stripeEmail"]').val()}
              }
            }
          ).then((result) => {
            if(result.setupIntent && result.setupIntent.status === "succeeded") {
                // Send the payment method to our server.
                var form = document.getElementById('payment-form');
                var hiddenInput = document.createElement('input');
                hiddenInput.setAttribute('type', 'hidden');
                hiddenInput.setAttribute('name', 'paymentMethod');
                hiddenInput.setAttribute('value', result.setupIntent.payment_method);
                form.appendChild(hiddenInput);
                
                
                var hiddenInput = document.createElement('input');
                hiddenInput.setAttribute('type', 'hidden');
                hiddenInput.setAttribute('name', 'hash');
                hiddenInput.setAttribute('value', this.payInfosHash);
                form.appendChild(hiddenInput);

                form.submit();
            } else {

                if(result.error.type === "validation_error") {
                    $('.btn-primary', '#payment-form').prop('disabled',false);
                } else {
                    Push.error(window.i18n.__("Impossible d'enregistrer les informations de paiement."));
                    this.$modal.dialog('close');
                }
                
            }

            
          });
    };
    
    handleCardPayment(){
        this.stripe.handleCardPayment(
            this.clientSecret, this.cardNumber, {
              payment_method_data: {
                billing_details: {email: $('input[name="stripeEmail"]').val()}
              },
              receipt_email : $('input[name="stripeEmail"]').val()
            }
          ).then((result) => {
            
            var form = document.getElementById('payment-form');
            var hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', 'hash');
            hiddenInput.setAttribute('value', this.payInfosHash);
            form.appendChild(hiddenInput);

            //strange return from stripe, key for payment intent  may differ depending the error
            if(result.paymentIntent) {
                var paymentIntentId = result.paymentIntent.id;
            } else if(result.error) {

                if(result.error.type === "validation_error") {
                    $('.btn-primary', '#payment-form').prop('disabled',false);
                    return;
                }

                var paymentIntentId = result.error.payment_intent.id;
            }

            var hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', 'paymentIntentId');
            hiddenInput.setAttribute('value', paymentIntentId);
            form.appendChild(hiddenInput);
                
            form.submit();

          });
    };

    setData(data) {
        this.publicKey      = data.key;
        this.btnLabel       = data.label;
        this.payLabel       = data.panelLabel;
        this.description    = data.description;
        this.formAction     = data.action;
        this.saveCard       = data.saveCard;
        this.payInfosHash   = data.hash;
        this.savedCardAlert = data.savedCardAlert;
        this.clientSecret   = data.clientSecret;
        this.charge         = data.charge;

        this.style = {
            base : {
                color : "#555555"
            },
            invalid : {
                color : "#F67D8C"
            }
        }; 
        
        //default options for card element
        this.options        = {style : this.style};
        this.stripe         = Stripe(this.publicKey);
        this.elements       = this.stripe.elements();
    };

    fetchData(){

        return new Promise((resolve) => {
            MyWindow.wait("modalStripe").css('position', 'absolute');
            
            $.post({
                url : `/stripe/checkout/request`,
                data :{hash : this.stripeData.hash, deadlineid : this.stripeData.deadlineid},
            }, function(result){
                resolve(result.data);
            });
        });
    }
    
};